import { defineComponent as _defineComponent } from 'vue'
import type { SocialIcon } from './constants';
import { socialIcons } from './constants';

type SocialIconsBarProps = {
  config?: Record<string, SocialIcon>;
  color?: string;
  size?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialIconsBar',
  props: {
    config: { default: () => socialIcons },
    color: { default: '#d8d8d8' },
    size: { default: 24 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})